import {createStyles} from '@mantine/core';
import React from 'react';

const useStyles = createStyles((theme) => ({
  pre: {
    width: '100%',
    height: '100%',
    minHeight: 28,
    margin: 0,
    overflow: 'auto',
    border: `1px solid ${theme.colors.gray[2]}`,
    borderRadius: theme.radius.sm,
    padding: theme.spacing.sm,
    fontFamily: theme.fontFamilyMonospace,
    fontSize: theme.fontSizes.sm,
    backgroundColor: theme.colors.gray[0],
    color: theme.colors.gray[9],
    boxSizing: 'border-box',
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word',
  },
}));

interface TextRendererProps {
  content: string;
}

export default function TextRenderer({content}: TextRendererProps): JSX.Element {
  const {classes} = useStyles();
  return <pre className={classes.pre}>{content}</pre>;
}
